var _excluded = ["property", "selectedRelationship", "onRelationshipChange", "onSubmit"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { BedIcon, BathIcon, ParkingIcon, EerIcon } from '@domain-group/fe-co-icon';
import { PropertyType } from '@domain-group/fe-allhomes-library';
import { Modal, RelationshipList } from '../../components';
import FeatureIcon from './feature-icon';
import * as styles from './follow-this-property.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var divider = '•';
var FollowThisProperty = _ref => {
  var _PropertyType$feature;
  var property = _ref.property,
    selectedRelationship = _ref.selectedRelationship,
    _ref$onRelationshipCh = _ref.onRelationshipChange,
    onRelationshipChange = _ref$onRelationshipCh === void 0 ? () => {} : _ref$onRelationshipCh,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? () => {} : _ref$onSubmit,
    modalProps = _objectWithoutProperties(_ref, _excluded);
  if (!property) {
    return modalProps.loading ? ___EmotionJSX(Modal, {
      title: "Add this property",
      buttonText: "Add this property",
      loading: true
    }, ___EmotionJSX("p", null)) : null;
  }
  var address = property.address,
    features = property.features;
  var handleRelationshipChange = rel => {
    onRelationshipChange(rel);
  };
  var handleSubmit = () => {
    onSubmit({
      relationship: selectedRelationship
    });
  };
  var showPropertyType = Boolean(PropertyType[features.propertyType] && !['OTHER', 'UNKNOWN'].includes(features.propertyType));
  return ___EmotionJSX(Modal, _extends({}, modalProps, {
    title: "Add this property",
    buttonText: "Add this property",
    onSubmit: handleSubmit,
    submitEvent: {
      name: 'follow-property-submit',
      data: {
        relationship: selectedRelationship
      }
    }
  }), ___EmotionJSX("div", {
    css: styles.propertyDetails
  }, ___EmotionJSX("h3", {
    css: styles.addressLine1
  }, address.line1), ___EmotionJSX("p", {
    css: styles.addressLine2
  }, address.division.name, ", ", address.state.abbrev, " ", address.postcode), ___EmotionJSX("div", {
    css: styles.features
  }, ___EmotionJSX(FeatureIcon, {
    icon: BedIcon,
    value: features.bedrooms
  }), ___EmotionJSX(FeatureIcon, {
    icon: BathIcon,
    value: features.bathrooms.total
  }), ___EmotionJSX(FeatureIcon, {
    icon: ParkingIcon,
    value: features.parking.total
  }), ___EmotionJSX(FeatureIcon, {
    icon: EerIcon,
    value: features.eer
  }), (features.bedrooms || features.bathrooms.total || features.parking.total || features.eer) && showPropertyType ? ___EmotionJSX("span", null, divider) : null, showPropertyType && ((_PropertyType$feature = PropertyType[features.propertyType]) !== null && _PropertyType$feature !== void 0 ? _PropertyType$feature : PropertyType.OTHER).label)), ___EmotionJSX("div", {
    css: styles.relationship
  }, ___EmotionJSX("div", {
    css: styles.relationshipText
  }, ___EmotionJSX("h3", {
    css: styles.relationshipHeading
  }, "What best describes you?"), ___EmotionJSX("p", null, "Your relationship with this property allows us to give you relevant insights")), ___EmotionJSX(RelationshipList, {
    selected: selectedRelationship,
    onChange: handleRelationshipChange
  })));
};
export default FollowThisProperty;